'use client';

import { ROUTES } from '@shared/constants/routes';

import cls from './DownloadButton.module.scss';

export const DownloadButton = () => {
  return (
    <a
      href={ROUTES.PRODUCT_CERTS}
      target="_blank"
      className={cls.download}
    >
      Скачать сертификаты продукции
    </a>
  );
};
